import instance from '../axios';
export const todayRevenue = async (id) => {
  const response = await instance.get(`reports/`);
  return response.data;
};

export const getSalesTrend = async (dateFrom, dateTo) => {
  const response = await instance.get(`transactions/sales-trend?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const getDailyTrend = async (dateFrom, dateTo) => {
  const response = await instance.get(`transactions/daily-trend?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const getMostUsedFrame = async (dateFrom, dateTo) => {
  const response = await instance.get(`transactions/most-used-frame?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};
export const getBestSellers = async (dateFrom, dateTo) => {
  const response = await instance.get(`reports/bestSeller?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};
export const getPaymentType = async (dateFrom, dateTo) => {
  const response = await instance.get(`reports/paymentType?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};
export const getTopSpenders = async (dateFrom, dateTo) => {
  const response = await instance.get(`reports/topSpenders?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};
export const getSummary = async (dateFrom, dateTo) => {
  const response = await instance.get(`reports/summary?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};
export const getMostUsedCategoryFrame = async (dateFrom, dateTo) => {
  const response = await instance.get(`transactions/most-used-category-frame?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const getTransactionList = async (dateFrom, dateTo, id, page, pageSize) => {
  const response = await instance.get(
    `transactions/transaction-list?dateFrom=${dateFrom}&dateTo=${dateTo}${
      id ? `&boothId=${id}` : ``
    }&page=${page}&pageSize=${pageSize}`
  );
  return response.data;
};

export const getReprintList = async (dateFrom, dateTo) => {
  const response = await instance.get(`transactions/reprint-list?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const getReprintSummary = async (dateFrom, dateTo) => {
  const response = await instance.get(`transactions/reprint-summary?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const getTransactionListById = async (id) => {
  const response = await instance.get(`transactions/transaction-by-id?id=${id}`);
  return response.data;
};

export const reportPerDay = async (dateFrom, dateTo) => {
  const response = await instance.get(`transactions/report-per-day?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const dailyRecap = async (dateFrom, dateTo) => {
  const response = await instance.get(`transactions/daily-recap?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};

export const bulkDailyRecap = async (dateFrom, dateTo) => {
  const response = await instance.get(`transactions/bulk-daily-recap?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  return response.data;
};
